import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-header-title',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './header-title.component.html',
    styleUrls: ['./header-title.component.scss'],
})
export class HeaderTitleComponent {
    @Input() title = '';
    @Input() subtitle = '';
}
